if (!customElements.get('localisation-redirect')) {
  const { Fancybox } = await import('@fancyapps/ui');

  class LocalisationRedirect extends HTMLElement {
    constructor() {
      super();

      this.options = {
        cookieName: 'country_redirect_done',
      };

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      // get html from webcomponent
      this.options.src = this.innerHTML;

      // get cookie
      const cookies = document.cookie.split(';');
      const countryRedirectPassed = cookies.find((cookie) => cookie.includes(this.options.cookieName));

      if (countryRedirectPassed) {
        return;
      }

      this.fetch();
    }

    /*
     * Fetch visitor country
     */
    async fetch() {
      await fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
        .then((response) => response.json())
        .then((response) => {
          const visitorCountry = response.detected_values.country.handle;

          if (visitorCountry != this.options.currentCountryCode && this.options.redirects[visitorCountry]) {
            const url = this.options.redirects[visitorCountry][1];
            const currentCountryName = this.options.redirects[visitorCountry][0];
            let siteName = url.replace('https://www.', '');
            siteName = siteName[0].toUpperCase() + siteName.slice(1);
            if (siteName.endsWith('/')) {
              siteName = siteName.slice(0, -1);
            }
            const src = this.options.src.replace(`href=""`, `href="${url}"`).replaceAll(`[1]`, currentCountryName).replaceAll(`[2]`, siteName);
            new Fancybox(
              [
                {
                  src: src,
                  type: 'html',
                },
              ],
              {
                on: {
                  done: (fancybox, eventName) => {
                    fancybox.$carousel.querySelector('[data-fancybox-close]').addEventListener('click', () => {
                      Fancybox.close();
                      // set cookie
                      const date = new Date();
                      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
                      document.cookie = `${this.options.cookieName}=true; expires=${date.toUTCString()}; path=/`;
                    });
                  },
                },
                animated: false,
                backdropClick: false,
                closeButton: false,
                dragToClose: false,
                autoFocus: false,
                mainClass: 'country-popup',
              }
            );
          }
        });
    }
  }
  customElements.define('localisation-redirect', LocalisationRedirect);
}
